export default "__VITE_ASSET__LJ9ZQNTE__"